import * as graphql from '@treams/treams-network';

import Emoticon from '../layout/Emoticon';
import EmoticonContainer from '../layout/EmoticonContainer';

export default function SentimentDisplay(props: { item: graphql.EvaluationSubmissionItem }) {
	const choices = ['😥', '😕', '🤔', '🙂', '😃'];
	const value = props.item.sentiment!;

	return (
		<EmoticonContainer>
			{choices.map((emoji, index) => (
				<Emoticon selected={value === index} key={index}>
					{emoji}
				</Emoticon>
			))}
		</EmoticonContainer>
	);
}
